import { Navigate } from "react-router";
import { useAuth } from "../context/useAuth";
import RouteLoader from "../../../components/ui/RouteLoader";
import { ROLE_INTERNAL_DOCTOR } from "../../../types/role";

interface PreventAuthAccessProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export function PreventAuthAccess({ children, redirectTo = "/inicio" }: PreventAuthAccessProps) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return <RouteLoader message="Verificando autenticação..." />;
  }

  if (isAuthenticated && user) {
    // Médico interno vai direto ao formulário; todos os demais entram pela home composta.
    const destination =
      user.role_id === ROLE_INTERNAL_DOCTOR ? "/formulario-interno" : redirectTo;

    return <Navigate to={destination} replace />;
  }

  return <>{children}</>;
}
